import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface DataScienceModelEntityParams {
  model_name: string;
  model_version: string;
}
export class DataScienceModelEntity extends BaseEntityClass {
  model_name: string;
  model_version: string;
  constructor(params: DataScienceModelEntityParams) {
    super();
    this.type = "data_science_model";
    this.entity_version = 2;
    this.model_name = params.model_name;
    this.model_version = params.model_version;
  }
}
